import { render } from "./NotificarEmbargoGobernacionComponent.vue?vue&type=template&id=d3b4ad6a"
import script from "./NotificarEmbargoGobernacionComponent.vue?vue&type=script&lang=js"
export * from "./NotificarEmbargoGobernacionComponent.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/tesoreria_tolima/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__